export type FaqQuestion = {
  title: string;
  content: string;
  id?: string;
};

export type FaqCategoryId = 'general' | 'investors' | 'borrowers';

export type FaqCategory = {
  id: FaqCategoryId;
  label: string;
  heading: string;
  questions: Array<FaqQuestion>;
};

const generalQuestions: Array<FaqQuestion> = [
  {
    title: 'Что такое Онлайн-платформа Кономика?',
    content:
      '<p>Онлайн-платформа «Кономика» – это автоматизированная система (далее – Платформа) в сети Интернет,' +
      ' используемая для заключения сделок по приобретению прав требования (долговых требований). Доступ к Платформе ' +
      'предоставляет Общество с ограниченной ответственностью «Кономика» (ИНН 9728069364, ОГРН 1227700435930).</p>',
  },
  {
    title: 'Вы привлекаете денежные средства и потом возвращаете их с процентами?',
    content:
      '<p>Нет. Платформа не привлекает денежные средства от пользователей. Она предоставляет только техническую ' +
      'возможность заключить сделку по приобретению прав требования, администрирует процесс оформления сделки, ' +
      'ведёт учёт обязательств, хранит документы по заключённым сделкам, а также предоставляет технические средства финансового учёта и мониторинга исполнения сделок. ' +
      'Денежные средства пользователи не предоставляют в долг Платформе.</p>',
  },
  {
    title: 'В чём суть работы Платформы?',
    content:
      '<p>С помощью программного обеспечения ООО «Кономика» пользователи могут:</p>' +
      '<ul><li>приобретать права требования;</li>' +
      '<li>продавать права требования;</li>' +
      '<li>предоставлять услуги по взысканию.</li></ul>' +
      '<p>Механизм работы следующий: </br> Продавец подаёт заявку на продажу принадлежащего ему права требования к третьему лицу.' +
      ' Заявка проходит проверку. Если требование соответствует критериям Платформы, оно размещается в системе. ' +
      'Право требования может быть приобретено как одним покупателем, так и по принципу софинансирования (несколько покупателей приобретают долю в требовании).</p>' +
      '<p>Сделка оформляется с привлечением Агента-взыскателя, который действует в интересах покупателей (Принципалов).' +
      ' Покупателям не требуется самим заниматься взысканием – этим занимается Агент. Услуги Агента платные, их стоимость указана в документах сервиса.</p>',
  },
  {
    title: 'Является ли деятельность Платформы легальной?',
    content:
      '<p>Да. Сделки уступки прав требования, заключаемые с использованием Платформы, регулируются нормами Гражданского кодекса РФ. Деятельность Платформы осуществляется на основании агентских договоров и Правил Онлайн-сервиса «Кономика».</p>',
  },
  {
    title: 'Кто может быть клиентом Платформы?',
    content:
      '<ul><li>Продавец права требования – юридические лица и индивидуальные предприниматели.</li>' +
      '<li>Покупатель права требования (Принципал) – юридические лица, ИП, физические лица.</li>' +
      '<li>Взыскатель (Агент) – только юридические лица.</li></ul>',
  },
  {
    title: 'В чём преимущества Платформы для продавцов долга?',
    content:
      '<p>Возможность быстро превратить задолженность в ликвидные средства и вернуть их в оборот.</p>',
  },
  {
    title: 'В чём преимущества для покупателей (инвесторов)?',
    content:
      '<p>Возможность разместить капитал в доходный инструмент с диверсификацией: требование к должнику может быть профинансировано сразу несколькими покупателями. Это снижает риски и формирует сбалансированный портфель.</p>',
  },
  {
    title: 'В чём преимущества для взыскателей (Агентов)?',
    content:
      '<ul><li>доступ к базе проверенных требований и скоринг-досье должников;</li>' +
      '<li>полная автоматизация документооборота в соответствии с ГК РФ;</li>' +
      '<li>закреплённый порядок агентских поручений и вознаграждения.</li></ul>',
  },
  {
    title: 'То есть Платформа соединяет три стороны?',
    content:
      'Да. Платформа является техническим решением для взаимодействия продавца, покупателя и Агента. Она обеспечивает:' +
      '<ul><li>фиксацию юридически значимых действий;</li><li>электронный документооборот;</li><li>учёт и статистику сделок;</li><li>управление денежными средствами через номинальный счёт.</li></ul>',
  },
  {
    title: 'На чём зарабатывает Платформа? Услуги платные?',
    content:
      '<p>Да. Услуги Платформы платные, их размер указан в разделе «Тарифы». Кроме того, в каждой сделке предусмотрено вознаграждение Агента.</p>',
  },
  {
    title: 'Как стать клиентом Платформы?',
    content:
      '<ul><li>Покупателям и продавцам необходимо пройти электронную регистрацию.</li> ' +
      '<li>Продавец может также направить заявку на электронную почту сервиса.</li></ul>',
  },
  {
    title: 'Можно ли покупать или продавать долги физических лиц?',
    content: '<p>Нет. Сделки с долгами физических лиц через Платформу невозможны.</p>',
  },
  {
    title: 'Должен ли покупатель сам заниматься взысканием?',
    content: '<p>Нет. Взыскание осуществляет Агент (взыскатель).</p>',
  },
];

const investorQuestions: Array<FaqQuestion> = [
  {
    title: 'Кто может быть покупателем долговых требований (инвестором)?',
    content:
      '<p>Юридические лица, индивидуальные предприниматели и физические лица, являющиеся налоговыми резидентами Российской Федерации.</p>',
  },
  {
    title: 'Есть ли риск в приобретении долговых требований?',
    content:
      '<p>Да. Существует риск, что долг не удастся взыскать (он может оказаться безнадежным). Платформа проводит проверку правового основания долга и скоринг должника, но не гарантирует успешного взыскания.</p>',
  },
  {
    title: 'Почему продавцу выгодно продать требование с дисконтом, если он может взыскать сам?',
    content:
      '<p>Продажа задолженности позволяет быстро закрыть кассовые разрывы и пополнить оборотные средства. У компаний сегмента МСП часто нет времени или ресурсов на ведение судебной работы и содержание юристов.</p>',
  },
  {
    title: 'Почему вы уверены, что сможете взыскать долг?',
    content:
      '<p>Взыскатель – это специализированная юридическая компания. На Платформе допущен один профессиональный Агент-взыскатель, имеющий многолетний опыт и значительный портфель успешных взысканий в сегменте МСП. В штате – 16 профессиональных юристов, специализирующихся на взыскании долгов.</p>',
  },
  {
    title: 'Как давно работает проект? Есть ли статистика?',
    content:
      '<p>Платформа «Кономика» начала работу в 2021 году.</p>' +
      '<p>На текущий момент:</p><ul>' +
      '<li>заключено более 450 сделок уступки прав требования на сумму свыше 6,9 млрд руб.;</li>' +
      '<li>взыскано более 7,7 млрд руб.;</li>' +
      '<li>активный портфель, находящийся в работе, составляет свыше 2,3 млрд руб.;</li>' +
      '<li>средняя доходность превышала ключевую ставку Банка России на ~15%.;</li></ul>' +
      '<li>средний срок оборачиваемости средств (срок цикла взыскания) составляет 8 месяцев.</li></ul>' +
      '<p>Актуальную статистику можно запросить у персональных менеджеров Платформы.</p>',
  },
  {
    title: 'Какие отношения между взыскателем и покупателем?',
    content:
      '<p>Они закреплены <b>агентским договором</b> (ст. 1005 ГК РФ). Агент действует от своего имени, но за счёт Принципала (инвестора).</p>',
  },
  {
    title: 'Покупатель платит за услуги взыскателя авансом?',
    content:
      '<p>Нет. Вознаграждение Агента удерживается из дохода, полученного в результате взыскания. Доход Агента зависит от результата его работы.</p>',
  },
  {
    title: 'Как технически заключается сделка?',
    content:
      '<p>1. Покупатель проходит регистрацию и заключает договор с Платформой и агентский договор с взыскателем.</br>' +
      '2. В личном кабинете доступна карточка сделки: параметры, результаты проверки документов и скоринга должника.</br>' +
      '3. Покупатель принимает решение и выдаёт Агенту поручение на участие в сделке, указывая при этом сумму покупки.</br>' +
      '4. Документооборот полностью электронный и подтверждается ЭЦП, формируемой внутри Платформы.</p>',
  },
  {
    title: 'Как происходит оплата долгового требования?',
    content:
      '<p>Покупатель переводит средства на номинальный счёт Агента. Агент оплачивает цеденту (продавцу) стоимость приобретённого требования.</p>',
  },
  {
    title: 'Что такое номинальный счёт?',
    content:
      '<p>Это банковский счёт, владелец которого – Агент, а бенефициарами являются покупатели. Средства на номинальном счёте:</p>' +
      '<ul><li>отделены от собственных средств Агента;</li>' +
      '<li>учитываются на учётных субсчётах каждого покупателя;</li>' +
      '<li>могут использоваться только в рамках поручений покупателей через Платформу.</li></ul>' +
      '<p>ООО «Кономика» не принимает и не хранит деньги покупателей на своих счетах.</p>',
  },
  {
    title: 'Нужно ли иметь УКЭП для сделок?',
    content:
      '<p>Нет. Платформа использует встроенную систему электронной подписи (простая ЭП).</p>',
  },
  {
    title: 'Где хранятся документы?',
    content:
      '<p>Все документы формируются в электронном виде, сохраняются внутри Платформы и доступны в личном кабинете не менее 5 лет.</p>',
  },
  {
    title: 'Как защищены мои данные?',
    content:
      '<p>Данные хранятся в программном комплексе Платформы. Уровень безопасности соответствует банковским стандартам. Серверы расположены на территории РФ.</p>',
  },
  {
    title: 'Как создать личный кабинет?',
    content: '<p>Достаточно пройти регистрацию на сайте Платформы.</p>',
  },
  {
    title: 'После регистрации Платформой можно сразу пользоваться?',
    content:
      '<p>После регистрации доступен ознакомительный режим. Для заключения сделок необходимо пройти верификацию:</p>' +
      '<ul><li>заполнить анкету;</li><li>пройти идентификацию;</li><li>заключить пользовательский договор с Платформой;</li><li>заключить агентский договор с взыскателем.</li></ul>',
  },
  {
    title: 'Может ли иностранец стать клиентом?',
    content: '<p>Нет. Услуги предоставляются только налоговым резидентам РФ.</p>',
  },
  {
    title: 'Нужно ли платить налоги с дохода?',
    content:
      '<p>Да. Налоги уплачиваются в соответствии с НК РФ и зависят от вашего статуса (физлицо, ИП, юрлицо).</p>' +
      '<p>Платформа не является налоговым агентом для физических лиц. В личном кабинете доступны отчётные документы для бухгалтерии и налоговой.</p>',
  },
  {
    title: 'Почему в документах используются термины Агент, Принципал, Бенефициар?',
    content:
      '<p>Эти термины применяются в гражданском праве:</p>' +
      '<ul><li><b>Покупатель (инвестор)</b> = Принципал;</li>' +
      '<li><b>Взыскатель</b> = Агент;</li>' +
      '<li><b>Покупатель, владелец средств на номинальном счёте</b> = Бенефициар.</li></ul>',
  },
  {
    title: 'Как зарегистрироваться в качестве покупателя долговых требований?',
    content:
      '<p>Регистрация производится на сайте Платформы через форму «Регистрация» и занимает несколько минут. Необходимо:</p>' +
      '<ul><li>ввести номер телефона,</li><li>создать пароль,</li><li>подтвердить действие смс-кодом.</li></ul>' +
      '<p>Номер телефона становится вашим логином для входа в личный кабинет. Через него также подтверждаются сделки.</p>',
  },
  {
    title: 'В чём отличие регистрации от верификации?',
    content:
      '<p><b>Регистрация</b> даёт ознакомительный доступ к Платформе, без ввода персональных данных.</p>' +
      '<p><b>Верификация</b> позволяет заключать сделки. Для этого требуется:</p>' +
      '<ul><li>указать персональные данные и загрузить паспорт,</li><li>согласиться с Правилами сервиса и Политикой обработки персональных данных.</li></ul>' +
      '<p>Только после этого вы заключаете Пользовательский договор.</p>',
  },
  {
    title: 'Может ли Платформа отказать в регистрации или верификации?',
    content:
      '<ul><li>Регистрация автоматическая, отказ возможен только если номер уже используется.</li>' +
      '<li>Верификация может быть отклонена, если вы предоставили недостоверные данные или подпадаете под категории, которым Платформа отказывает в доступе.</li></ul>',
  },
  {
    title: 'Когда точно откажут в доступе?',
    content:
      '<p>Отказ возможен, если:</p>' +
      '<ul><li>вы несовершеннолетний;</li><li>вы не налоговый резидент РФ;</li><li>вы находитесь в стоп-листе по 115-ФЗ.</li></ul>',
  },
  {
    title: 'Что является логином и паролем? Можно ли их изменить?',
    content:
      '<ul><li>Логин – ваш номер телефона.</li>' +
      '<li>Пароль – комбинация символов, указанная при регистрации.</li></ul>' +
      'Оба можно изменить через личный кабинет.',
  },
  {
    title: 'Можно ли изменить данные, указанные при регистрации/верификации?',
    content: '<p>Да, изменения вносятся через личный кабинет.</p>',
  },
  {
    title: 'Зачем Платформа запрашивает персональные данные? Это безопасно?',
    content:
      '<p>Данные нужны для идентификации стороны договора. Хранение и обработка осуществляется в соответствии с ФЗ-152 «О персональных данных». Политика обработки опубликована на сайте.</p>',
  },
  {
    title: 'Какие договоры я заключаю с Платформой и как?',
    content:
      '<ul><li><b>С Платформой</b> – при верификации, путём акцепта Правил (договор присоединения, ст. 428 ГК РФ).</li>' +
      '<li><b>С взыскателем (Агентский договор)</b> – после верификации, путём акцепта оферты (ст. 433, 438 ГК РФ).</li></ul>' +
      '<p>Все договоры заключаются в электронном виде, УКЭП не требуется.</p>',
  },
  {
    title: 'Почему договор с Платформой и договор с взыскателем разделены?',
    content:
      '<ul><li>Платформа оказывает технические услуги (информирование, фиксация фактов, хранение документов).</li>' +
      '<li>Взыскатель представляет интересы покупателя, в том числе в суде. Это разные услуги и разные юридические лица, поэтому заключаются отдельные договоры.</li></ul>',
  },
  {
    title: 'Можно ли изменить условия договора под себя?',
    content: '<p>Нет. Договоры стандартизированы и едины для всех пользователей.</p>',
  },
  {
    title: 'Как Платформа меня идентифицирует?',
    content:
      '<p>Автоматически: данные верификации сверяются с банковскими данными при зачислении средств на номинальный счёт. В случае расхождений средства возвращаются на исходный счёт, а Платформа может запросить дополнительные документы.</p>',
  },
  {
    title: 'Где хранятся мои договоры?',
    content:
      '<p>Все документы сохраняются внутри Платформы и автоматически передаются в банк, где открыт номинальный счёт.</p>',
  },
  {
    title: 'Можно ли запросить подтверждение заключения договора?',
    content:
      '<p>Да. По запросу Сервис или Агент предоставят заверенное УКЭП письмо с подтверждением факта и текста договора.</p>',
  },
  {
    title: 'Номинальный счёт принадлежит не мне, почему средства на нём считаются моими?',
    content:
      '<p>Потому что это специальный счёт по ст. 860.1 ГК РФ. Средства на нём принадлежат третьим лицам (бенефициарам). Агент лишь владелец счёта, но не собственник средств.</p>',
  },
  {
    title: 'Надо ли заключать договор с банком?',
    content: '<p>Нет. Договор с банком заключает Агент (взыскатель).</p>',
  },
  {
    title:
      'Как я могу быть уверен, что условия использования моих средств защищены от злоупотреблений со стороны владельца номинального счёта?',
    content:
      '<p>Банк и владелец номинального счёта (Агент) согласовывают порядок платежей и перечень подтверждающих документов. В банк предоставляются все договоры, заключённые пользователем с Платформой и Агентом. Платёж возможен только при наличии поручения пользователя и полного комплекта документов. Если условия нарушены – банк платёж не проведёт.</p>',
  },
  {
    title: 'Как я могу выдать поручение на оплату?',
    content:
      '<p>Поручение формируется в личном кабинете Платформы. Подтверждается с помощью двухфакторной аутентификации (смс-код). Платформа фиксирует факт поручения и передаёт его Агенту. Оплату инициирует Агент через API Платформы. Все поручения хранятся в защищённом модуле не менее 5 лет и копируются в банк.</p>',
  },
  {
    title: 'Как пополнить номинальный счёт?',
    content:
      '<p>Пополнение возможно только после заключения Агентского договора. Перевод делается с вашего банковского счёта на реквизиты номинального счёта (указаны в личном кабинете). В назначении платежа обязательно указывается номер договора.</p>',
  },
  {
    title:
      'Можно ли пополнить счёт с чужого счёта, наличными, криптовалютой или в иностранной валюте?',
    content:
      '<p>Нет. Допускаются только переводы со счёта пользователя в банке, имеющем лицензию в РФ, в рублях.</p>',
  },
  {
    title: 'Если счёт один, как определяется, где чьи деньги?',
    content:
      '<p>Внутри номинального счёта ведутся субсчета, каждый из которых закреплён за пользователем.</p>',
  },
  {
    title: 'Как я вижу свои средства?',
    content: '<p>В личном кабинете отражается состояние вашего субсчёта на номинальном счёте.</p>',
  },
  {
    title: 'Как вывести средства?',
    content:
      '<p>В личном кабинете вы подаёте распоряжение, которое автоматически передаётся в банк через API.</p>',
  },
  {
    title: 'Сколько стоит обслуживание номинального счёта?',
    content: '<p>Для покупателя – бесплатно. Расходы включены в тарифы Платформы и Агента.</p>',
  },
  {
    title: 'Какие операции возможны по номинальному счёту?',
    content:
      '<ul><li><b>Входящие:</b> зачисления от покупателей; поступления от должников.</li><br/>' +
      '<li><b>Исходящие:</b> оплата уступки требования; вознаграждение Платформы и Агента; уплата налогов; возврат средств пользователю.</li></ul>',
  },
  {
    title: 'Кто контролирует операции?',
    content:
      '<p>Контроль осуществляет банк. Он проверяет каждый платёж на соответствие регламенту и наличию документов (договор цессии, поручение, реестр участников сделки).</p>',
  },
  {
    title: 'Где получить информацию об остатках и транзакциях?',
    content:
      '<p>В личном кабинете доступны все данные по сделкам и операциям, копии договоров и поручений.</p>',
  },
  {
    title: 'Можно ли провести сделку, минуя номинальный счёт?',
    content: '<p>Нет. Все расчёты проходят только через номинальный счёт.</p>',
  },
  {
    title: 'Что если Платформа окажется временно недоступна?',
    content:
      '<ul><li>Документы и реестры хранятся на отдельном сервере у ООО «Кономика».</li>' +
      '<li>Данные также есть у Агента и банка. </li>' +
      '<li>Банк и Агент могут продолжить операции напрямую без Платформы.</li></ul>',
  },
  {
    title: 'Что будет, если банк закроет номинальный счёт?',
    content:
      '<p>Есть два сценария:</p><ul>' +
      '<li>Открывается новый номинальный счёт, средства переводятся туда.</li>' +
      '<li>Средства возвращаются пользователям пропорционально остаткам на их субсчетах.</li></ul>',
  },
  {
    title: 'Распространяется ли система страхования вкладов на номинальный счёт?',
    content: '<p>Нет. Государственная гарантия вкладов на такие счета не распространяется.</p>',
  },
];

const borrowerQuestions: Array<FaqQuestion> = [
  {
    title: 'Какие долги можно продать? Каков диапазон суммы?',
    content:
      '<p>«Кономика» работает с правами требования к юридическим лицам в размере от <b>5 млн до 200 млн рублей.</b> Были сделки и крупнее, но основной диапазон интереса покупателей составляет 10–50 млн рублей — такие сделки наиболее ликвидны.</p>',
  },
  {
    title: 'Какие долги нельзя продать через Платформу?',
    content:
      '<p>Не допускаются к продаже права требования, если:</p>' +
      '<ul>' +
      '<li>должником является физическое лицо;</li>' +
      '<li>должником является индивидуальный предприниматель;</li>' +
      '<li>должником является иностранное юридическое лицо;</li>' +
      '<li>должник находится в стадии банкротства или ликвидации;</li>' +
      '<li>требование связано с исполнением государственного оборонного заказа либо должником выступает предприятие оборонно-промышленного комплекса;</li>' +
      '<li>требование носит корпоративный характер (например, споры между участниками/акционерами о правах и обязанностях внутри общества);</li>' +
      '<li>предметом уступки являются убытки, которые не подтверждены судебным актом (не «просужены»);</li>' +
      '<li>предметом уступки являются требования, вытекающие из инвестиционных договоров и соглашений (в т.ч. договоров о совместной деятельности, договоров инвестирования).</li>' +
      '</ul>',
  },
  {
    title: 'Почему должником не может быть ИП?',
    content:
      '<p>Для ИП отсутствует достаточный массив достоверных данных, необходимых для полноценной проверки платёжеспособности и скоринга.</p>',
  },
  {
    title: 'Как определяется цена уступки требования?',
    content:
      '<p>Цена зависит от совокупности факторов:</p>' +
      '<ul>' +
      '<li>сумма требования;</li>' +
      '<li>финансовое состояние должника;</li>' +
      '<li>прогнозный срок взыскания;</li>' +
      '<li>юридическая сложность и затраты на взыскание;</li>' +
      '<li>текущая стоимость фондирования (ставки на рынке).</li>' +
      '</ul>' +
      '<p>Пример:</p>' +
      '<ul>' +
      '<li>по ликвидным требованиям со сроком взыскания в несколько месяцев дисконт может составлять около 20%;</li>' +
      '<li>по сложным и «долгим» требованиям дисконт может достигать 50% и более.</li>' +
      '</ul>',
  },
  {
    title: 'Почему бизнесу выгодно продать долг, а не привлекать кредит?',
    content:
      '<ul><li>Кредит требует рассмотрения в течение двух и более месяцев, а продажа права требования занимает в среднем до 10 дней.</li>' +
      '<li>Кредит в банке требует обеспечения и обширного пакета документов, а уступка права требования — только подтверждающих документов по задолженности.</li>' +
      '<li>У небанковских кредиторов условия мягче, но ставки намного выше. Кроме того, кредит нужно возвращать, сохраняя риск невозврата дебиторской задолженности.</li>' +
      '<li>При продаже права требования бизнес получает деньги сразу и снимает с себя риск взыскания.</li></ul>',
  },
  {
    title: 'Какие риски продажа помогает снять?',
    content:
      '<ul>' +
      '<li>недостаточная компетенция штатных юристов во взыскании;</li>' +
      '<li>конфликт интересов с давними контрагентами;</li>' +
      '<li>накопление задолженности из-за нежелания портить отношения с партнёром;</li>' +
      '<li>ухудшение балансовых показателей из-за «длинной» дебиторки.</li>' +
      '</ul>',
  },
  {
    title: 'Не испортит ли продажа долга отношения с должником?',
    content:
      '<p>Нет. Это распространённый инструмент фондирования. Должник понимает, что компания использовала рыночный механизм. В практике встречались случаи, когда должник предлагал отступное (например, уступку требования к третьему лицу) для урегулирования задолженности. Платформа и Агент также применяют медиативный подход при работе с должниками.</p>',
  },
  {
    title: 'Как юридически оформляется сделка?',
    content: '<p>Сделка оформляется договором уступки права требования (цессии).</p>',
  },
  {
    title: 'Как подписывается договор?',
    content:
      '<p>Продавец (цедент) и Агент (действующий в интересах инвесторов) подписывают договор либо УКЭП, либо собственноручно (в зависимости от выбранной формы).</p>',
  },
  {
    title: 'Что нужно, чтобы подать заявку на продажу долга?',
    content:
      "<p>Отправить на электронную почту Платформы – <a href='mailto:info@conomica.ru'>info@conomica.ru</a> предварительную заявку с указанием:</p>" +
      '<ul>' +
      '<li>ИНН продавца;</li>' +
      '<li>ИНН должника;</li>' +
      '<li>сумма требования;</li>' +
      '<li>ожидаемая цена уступки.</li>' +
      '</ul>' +
      '<p>Далее с продавцом связывается сотрудник отдела андеррайтинга для уточнения пакета документов.</p>',
  },
  {
    title: 'Когда продавец получает деньги?',
    content: '<p>Обычно сделка завершается в течение 10 календарных дней.</p>',
  },
];

export const faqCategories: Array<FaqCategory> = [
  {
    id: 'general',
    label: 'Общие вопросы',
    heading: 'Общие вопросы о платформе',
    questions: generalQuestions,
  },
  {
    id: 'investors',
    label: 'Инвесторам',
    heading: 'Инвесторам',
    questions: investorQuestions,
  },
  {
    id: 'borrowers',
    label: 'Продавцам долговых требований',
    heading: 'Продавцам долговых требований',
    questions: borrowerQuestions,
  },
];

export const faqQuestionsTotal = faqCategories.reduce(
  (total, category) => total + category.questions.length,
  0
);
